import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class BinaAsinmaOranlariAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "BinaAsinmaOranlariListe";
        super(baseUrl);
    }

    getBinaAsinmaOranlariListe(yili?: number, insaatTuruKodu?: number) {
        return this.get("", { params: { yili: yili, insaatTuruKodu: insaatTuruKodu } });

    }
}
export default new BinaAsinmaOranlariAPI();